import React, { useEffect, useState } from 'react'
import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
} from '@chakra-ui/react';
import { MdAdd, MdDelete } from 'react-icons/md'
import { TiInputChecked } from 'react-icons/ti'
import ReactPaginate from 'react-paginate'
import { Button, Form, Modal } from 'react-bootstrap';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { addSuggestion, deleteSuggestion, updateSuggestion, viewAllSuggestion, viewSuggestionById } from '../../../redux/actions/Doctor.action';
import { FiTarget } from 'react-icons/fi';
import { FaEdit } from 'react-icons/fa';
import { PiWarningCircleBold } from 'react-icons/pi';

const SuggestionCard = ({ patientIds }) => {

    const [show, setShow] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [viewModal, setViewModal] = useState(false);
    const [suggestionId, setSuggestionId] = useState();

    const toggle = () => { setShow(!show) }
    const updateToggle = () => { setUpdateModal(!updateModal); };
    const deleteToggle = () => { setDeleteModal(!deleteModal) };
    const viewToggle = () => { setViewModal(!viewModal) }
    const type = localStorage.getItem('type')
    const dispatch = useDispatch();
    const doctorData = useSelector((state) => state.doctor)
    const suggstionData = doctorData?.viewSuggestionById?.data

    const [mainPage, setMainPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(3);
    const limits = {
        page: mainPage,
        limit: rowsPerPage,
    };

    const initialValues = {
        treatmentName: ''
    }

    const [formData, setFormData] = useState({ treatmentName: '' })

    const validationSchema = Yup.object().shape({
        treatmentName: Yup.string().required('Suggetion is required')
    });

    const handleSuggestion = (values, { resetForm }) => {
        const payload = {
            treatmentName: values.treatmentName,
            patientId: patientIds
        }
        dispatch(addSuggestion(payload, patientIds, limits)).then(() => {
            toggle();
            resetForm();
        });
    };

    const ChangeMainPage = (selected) => {
        setMainPage(parseInt(selected.selected) + 1);
    };

    const handleRowsPerPageChange = (e) => {
        const newRowsPerPage = parseInt(e.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setMainPage(1);
    };

    const postPerPage = rowsPerPage;
    const PageCount = Math.ceil(
        doctorData?.viewAllSuggestion?.data?.totalCount / postPerPage,
    );

    const handleDelete = () => {
        dispatch(deleteSuggestion(suggestionId, patientIds, limits)).then(() => {
            deleteToggle()
            setMainPage(1)
        })
    }

    const handleUpdate = (values) => {
        const payload = {
            treatmentName: values.treatmentName
        }
        dispatch(updateSuggestion(payload, suggestionId, patientIds, limits)).then(() => {
            updateToggle()
        })
    }

    const handleView = (id) => {
        dispatch(viewSuggestionById(id))
    }

    useEffect(() => {
        if (patientIds) {
            dispatch(viewAllSuggestion(patientIds, limits))
        }
    }, [patientIds, mainPage, rowsPerPage])

    return (
        <>
            <div className='col-lg-6'>
                <div className="!bg-[#fff] shadow p-4 rounded-4 h-full">
                    <div className="d-flex justify-between">
                        <div className="flex gap-3 items-center">
                            <TiInputChecked className="fs-4" />
                            <h6 className="mb-0">Treatment Suggestion</h6>
                        </div>

                        <div onClick={toggle} className="w-[30px] flex justify-center items-center h-[30px] rounded-circle !border-red-700 border-1 cursor-pointer">
                            <button disabled={type === 'Receptionist'} className={`${type === 'Receptionist' ? 'cursor-not-allowed' : 'cursor-pointer'}`}><MdAdd className="fs-4 text-danger fw-bold" /></button>
                        </div>
                    </div>
                    <div className="mt-3">
                        <TableContainer>
                            <Table variant="simple" className="table-bordered">
                                <Thead className="!bg-theme-dark">
                                    <Tr>
                                        <Th className="!text-white">Date</Th>
                                        <Th className="!text-white">Suggestion</Th>
                                        <Th className="!text-white">User</Th>
                                        <Th className="!text-white">Action</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {
                                        doctorData?.viewAllSuggestion?.data?.treatmentData?.length > 0 ? (
                                            doctorData?.viewAllSuggestion?.data?.treatmentData?.map((res) => {
                                                return (
                                                    <Tr key={res._id}>
                                                        <Td>{new Date(res.createdAt).toLocaleDateString()}</Td>
                                                        <Td>{res.treatmentName}</Td>
                                                        <Td>{res?.authdata}</Td>
                                                        <Td>
                                                            <div className='flex gap-3 items-center'>
                                                                <button disabled={type === 'Receptionist'} className={`${type === 'Receptionist' ? 'cursor-not-allowed' : 'cursor-pointer'}`} onClick={() => { viewToggle(); handleView(res?._id); }}><FiTarget className='text-primary' title='view' /></button>
                                                                <button disabled={type === 'Receptionist'} className={`${type === 'Receptionist' ? 'cursor-not-allowed' : 'cursor-pointer'}`} onClick={() => { updateToggle(); setFormData(res); setSuggestionId(res?._id) }}><FaEdit className='text-success' title='update' /></button>
                                                                <button disabled={type === 'Receptionist'} className={`${type === 'Receptionist' ? 'cursor-not-allowed' : 'cursor-pointer'}`} onClick={() => { deleteToggle(); setSuggestionId(res?._id) }}><MdDelete className="text-danger" title="delete" /></button>
                                                            </div>
                                                        </Td>
                                                    </Tr>
                                                )
                                            })
                                        ) : (
                                            <Tr>
                                                <Td colSpan={4} textAlign={'center'}>No any suggestion</Td>
                                            </Tr>
                                        )
                                    }
                                </Tbody>
                            </Table>
                        </TableContainer>
                    </div>
                    <div className="flex justify-between items-center mt-2 text-sm">
                        <div>
                            Rows per page:
                            <select
                                value={rowsPerPage}
                                onChange={handleRowsPerPageChange}
                                className="ms-2 border rounded-md focus:outline-none"
                            >
                                <option value="">Select</option>
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={30}>30</option>
                                <option value={50}>50</option>
                            </select>
                        </div>

                        <ReactPaginate
                            breakLabel="..."
                            nextLabel=" >"
                            onPageChange={ChangeMainPage}
                            pageRangeDisplayed={5}
                            pageCount={PageCount}
                            previousLabel="< "
                            renderOnZeroPageCount={null}
                            className="pagination"
                        />
                    </div>
                </div>
            </div>

            {/* add suggestion */}
            <Modal show={show} onHide={toggle}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Suggestion</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSuggestion}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Suggestion</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="treatmentName"
                                                as='textarea'
                                                rows={3}
                                                onChange={(e) =>
                                                    setFieldValue('treatmentName', e.target.value)}
                                                value={values.treatmentName}
                                                placeholder="Enter Suggestion"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="treatmentName"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={toggle}
                                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                >
                                    Close
                                </Button>
                                <Button
                                    type="submit"
                                    className="!bg-theme-dark border-0 px-4"
                                // onClick={}
                                >
                                    Add
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

            {/* update suggestion */}
            <Modal show={updateModal} onHide={updateToggle}>
                <Modal.Header closeButton>
                    <Modal.Title>Update Suggestion</Modal.Title>
                </Modal.Header>
                <Formik
                    enableReinitialize={true}
                    initialValues={formData}
                    validationSchema={validationSchema}
                    onSubmit={handleUpdate}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Suggestion</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="treatmentName"
                                                as='textarea'
                                                rows={3}
                                                onChange={(e) =>
                                                    setFieldValue('treatmentName', e.target.value)}
                                                value={values.treatmentName}
                                                placeholder="Enter Suggestion"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="treatmentName"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={updateToggle}
                                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                >
                                    Close
                                </Button>
                                <Button
                                    type="submit"
                                    className="!bg-theme-dark border-0 px-4"
                                >
                                    Update
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

            {/* delete suggestion */}
            <Modal show={deleteModal} onHide={deleteToggle}>
                <Modal.Body className='p-5'>
                    <div>
                        <PiWarningCircleBold className='text-7xl w-100 text-danger' />
                    </div>
                    <div className='text-center mt-4'>
                        <h3>Are You Sure ?</h3>
                        <p className='text-md'>Do you really want to delete these records?</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={deleteToggle}
                        className="px-4 bg-transparent border-[1px] text-black border-green-color"
                    >
                        No
                    </Button>
                    <Button
                        type="submit"
                        className="bg-danger border-0 px-4"
                        onClick={handleDelete}
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* View feedback */}
            <Modal show={viewModal} onHide={viewToggle}>
                <Modal.Header closeButton>
                    <Modal.Title>View Feedback</Modal.Title>
                </Modal.Header>
                <Modal.Body className=''>
                    <div className='row gy-2'>
                        <div className='col-4'>Suggestion</div>
                        <div className='col-1'>:</div>
                        <div className='col-7'>{suggstionData?.treatmentData?.treatmentName}</div>

                        <div className='col-4'>Date</div>
                        <div className='col-1'>:</div>
                        <div className='col-7'>{new Date(suggstionData?.treatmentData?.createdAt).toLocaleDateString()}</div>

                        <div className='col-4'>User</div>
                        <div className='col-1'>:</div>
                        <div className='col-7'>{suggstionData?.authData?.name}</div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={viewToggle}
                        className="px-4 bg-transparent border-[1px] text-black border-green-color"
                    >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default SuggestionCard
